import '../App.css';
import React from 'react';
import { connect } from 'react-redux';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import ViewReceiptModal from '../Component/ViewReceiptModal';
import DisplayTable from '../Component/DisplayTable';
import Header from '../Component/Header';
import Select from "react-select";
import { language } from '../language';
// import { ExportPdf } from '../ExportPdf';
import ApproverCashOutModal from '../Component/ApproverCashOutModal';
import MultiplePrint from '../Component/MultiplePrint';
import RedoReturnModal from '../Component/RedoReturnModal';
// import loading from '../image/Loading.gif';
import { exportCashOutReportExcel } from '../jsonToXlsx';
import { ApproverCashoutClaim, rejectClaimFNC, cashOutClaimFNC, 
  EditClaim, returnClaimFNC, getClaimHistoryRecordFNC, getUser, getCategory, headerFilterFNC, cashOutClaimListFNC, exportClaimListFNC, DeleteClaim, returnCategoryFNC } from '../Api'
import moment from 'moment-timezone';

var timer

class CashOut extends React.Component {

  fileArray = [];
  constructor(props) {
    super(props);
    this.state = {
      Password: '',
      ConsirmPass: false,
      ErrorMessage: '',
      fasttype: '',
      OpenViewReceiptModal: false,
      ClaimViewReceipt: '',
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      fromDate: moment(new Date()).subtract(2, 'months').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      // fromDate: '2023-05-06',
      // toDate: '2023-05-06',
      claimData: [],
      AllClaimData: [],
      fastCashOutClaim: false,
      pagetype: 'CashOut',
      SelectedCashOutClaim: [],
      SelectedRejects: [],
      fastActionsReject: false,
      uploadloading: false,
      SelectedClaimObject: {},
      SelectedFilterStatus: 'All',
      ShowFilterName: 'All',
      ShowFilterDepart: 'All',
      ShowFilterBranch: 'All',
      ShowFilterSub: 'All',
      ShowFilterSubSub: 'All',
      ShowFilterApprovalStatus: 'All',
      ShowFilterSecondApprovalStatus: 'All',
      SelectFilterCompany: 'All',
      ShowFilterApproveAmount: 'All',
      ShowFilterAmount: 'All',
      ShowFilterApprover: 'All',
      ShowFilterSecondApprover: 'All',
      ShowFilterAccounting: 'All',
      FilterStatus: [],
      FilterName: [],
      FilterDepartment: [],
      FilterCompany: [],
      FilterBranch: [],
      FilterSub: [],
      FilterApprovalStatus: [],
      FilterSecondApprovalStatus: [],
      FilterAmount: [],
      FilterApprove: [],
      FilterSecondApprover: [],
      FilterAccounting: [],
      ReasonText: '',
      ReturnClicked: false,
      RedoReturnModal: false,
      TotalAmount: {TotalAmount: 0, TotalApproveAmount: 0},
      background: '#0D6EFD',
      OpenReceipt: false,
      DisplayHistory: false,
      HistoryData: [],
      MultiCashout: false,
      FilterApproveAmount: [],
      FilterSubSub: [],
      Amount: '',
      ShowReportBoolean: false,
      OpenFilter: true,
      CompanyList: [],
      BranchList: [],
      DepartmenList: [],
      CompanyBranch: [],
      CategoryList: [],
      Sub1List: [],
      Sub2List: [],
      Sub3List: [],
      Sub4List: [],
      Sub5List: [],
      Sub6List: [],
      UserList: [],
      LatestUpdateList: [
        'Pending',
        'Approve',
        'CashOut',
        'Reject',
      ],
      FirstApprove: '',
      FirstApproveStatus: '',
      SecondApprove: '',
      SecondApproveStatus: '',
      Accountant: '',
      SelectCompany: '',
      SelectBranch: [],
      SelectDepartment: [],
      SelectedSub1: '',
      SelectedSub2: '',
      SelectedSub3: '',
      SelectedSub4: '',
      SelectedSub5: '',
      SelectedSub6: '',
      SelectName: 'All',
      SelectCategory: '',
      SelectLatestUpdate: '',
      KeyinAmount: '',
      ApprovedAmount: '',
      page: 1,
      countperpage: 20,
      countpagemax: 1,
      countpagemin: 1,
      TotalPages: 1,
      RunTotalPage: [],
      BorderHide: true,
      AllSelectedIDs: [],
      DisplayMultiReceipt: false,
      SelectedOptionBranch: [],
      SelectedBranchs: [],
      SelectedDeparts: [],
      SelectedOptionDepart: [],
      BooleanRemoveN: false,
    }
    this.FilterTableView = this.FilterTableView.bind(this);
    this.WatchReceipt = this.WatchReceipt.bind(this);
    this.CloseViewReceipt = this.CloseViewReceipt.bind(this);
    this.SelectedRejects = this.SelectedRejects.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.OpenApproveModal = this.OpenApproveModal.bind(this);
    this.OpenRedoReturnModal = this.OpenRedoReturnModal.bind(this);
    this.ConfirmAction = this.ConfirmAction.bind(this);
    this.SelectedCashOut = this.SelectedCashOut.bind(this);
    this.RedoActions = this.RedoActions.bind(this);
    // this.ExportReceipt = this.ExportReceipt.bind(this);
    this.CloseConfirmPAss = this.CloseConfirmPAss.bind(this);
    this.OpenonfirmPAss = this.OpenonfirmPAss.bind(this);
    this.OnchangePassword = this.OnchangePassword.bind(this);
    this.ConfirmPasswordAPI = this.ConfirmPasswordAPI.bind(this);
    this.OpenReceipt = this.OpenReceipt.bind(this);
    this.DisplayHistorySet = this.DisplayHistorySet.bind(this);
    this.SetStatePage = this.SetStatePage.bind(this);
    this.SetStateProps = this.SetStateProps.bind(this);
    this.RunPageViews = this.RunPageViews.bind(this);
    this.handleXLSX = this.handleXLSX.bind(this);
    this.SelectAll = this.SelectAll.bind(this);
    this.DeleteClaims = this.DeleteClaims.bind(this);
    this.SelectedReAllID = this.SelectedReAllID.bind(this);
  }

  async componentDidMount() {
    if(this.props.token === '') {
      localStorage.removeItem('claimtoken');
      localStorage.removeItem('claimusername');
      localStorage.removeItem('claimrole');
      localStorage.removeItem('CompanyData');
      window.location.href = '/';
    }
    let FilterCompany = '';
    let getUserList = '';
    if (this.props.role !== 'User') {
      getUserList = await getUser(
        this.props.username, 
        this.props.token,
      );
    } else {
      getUserList = [];
    }
    const getCompanyList = JSON.parse(this.props.CompanyData)
    this.FilteredBranch(JSON.parse(this.props.CompanyData));
    FilterCompany = getCompanyList.map((item) => item.Company)
    FilterCompany = [...new Set(FilterCompany)];
    const CheckRoleBoolean = this.props.role === 'CEO' ? true : false
    this.setState({ 
      CompanyList: FilterCompany, 
      CompanyBranch: getCompanyList,
      UserList: getUserList,
      BorderHide: CheckRoleBoolean,
      // TableLoading: false
    });
    if (getUserList.error === 'Invalid credentials!') {
      localStorage.removeItem('claimtoken');
      localStorage.removeItem('claimusername');
      localStorage.removeItem('claimrole');
      localStorage.removeItem('CompanyData');
      this.props.setLoginStatus('', '', '');
      alert('Token Error');
      this.props.history.push('/')
    }
    let searchState = this.props.location.search.substring(1, this.props.location.search.length)
    if (searchState !== '') {
      searchState = `{"${decodeURI(searchState.replace(/&/g, "\",\"").replace(/=/g,"\":\""))}"}`
      searchState = JSON.parse(searchState)
      const fromDate = (searchState.WholeYear === 'true') ? `${searchState.Year}-01-01` : `${searchState.Year}-${searchState.Month}-01`
      const Todate = (searchState.WholeYear === 'true') ? `${searchState.Year}-12-31` : `${searchState.Year}-${searchState.Month}-${this.GetDay(searchState.Month, searchState.Year)}`
      this.setState({ SelectCompany: searchState.Company, SelectBranch: searchState.Branch, SelectCategory: searchState.Category, fromDate , toDate: Todate, SelectLatestUpdate: searchState.LatestStatus })
    }
    this.UserCallApi();
  }

  async getCategories() {
    const getCate = await returnCategoryFNC(this.state.SelectName, this.props.username, this.props.token, this.state.SelectDepartment)
    this.setState({ 
      FilterSub: getCate,
    })
  }

  RunTotalPage() {
    const TotalPages = this.state.TotalPages
    let RunTotalPage = this.state.RunTotalPage
    if (this.state.page === 1 && RunTotalPage.length === 0) {
      if(TotalPages > 5) {
        for(var i=0; i < 5; i++) {
          RunTotalPage.push(i+1)
        }
        this.setState({ RunTotalPage })
      } else {
        for(var z=0; z < TotalPages; z++) {
          RunTotalPage.push(z+1)
        }
        this.setState({ RunTotalPage })
      }
    }
  }

  GetDay(Month, year) {
    if(Month === '01' || Month === '03' || Month === '05' || Month === '07' || Month === '08' || Month === '10' || Month === '12') {
      return '31'
    } else if (Month === '04' || Month === '06' || Month === '09' || Month === '11') {
      return '30'
    } else if (Month === '02'){
      return moment(`${year}-${Month}`).endOf('month').format('DD')
    }
  }

  async CallHeader() {
    this.getCategories()
    const getheader = await headerFilterFNC(this.state.fromDate, this.state.toDate, 'CashOut', this.props.username, this.props.token);
    if (getheader) {
      let ArrayDepart = []
      getheader.FilterDepartment.forEach((items) => {
        ArrayDepart.push({value: items, label: items})
      })
      this.setState({ 
        FilterAccounting: getheader.FilterAccounting,
        FilterAmount: getheader.FilterAmount,
        FilterApprovalStatus: getheader.FilterApprovalStatus,
        FilterApprove: getheader.FilterApprove,
        SelectedOptionDepart: ArrayDepart,
        FilterApproveAmount: getheader.FilterApproveAmount,
        FilterBranch: getheader.FilterBranch,
        FilterCompany: getheader.FilterCompany,
        FilterDepartment: getheader.FilterDepartment,
        FilterName: getheader.FilterName,
        FilterSecondApprovalStatus: getheader.FilterSecondApprovalStatus,
        FilterSecondApprover: getheader.FilterSecondApprover,
        FilterStatus: getheader.FilterStatus,
        // FilterSub: getheader.FilterSub,
        FilterSubSub: getheader.FilterSubSub,
      })
    }
  }
  
  FilteredBranch(CompanyData) {
    let Branchs = []
    let FilterBranch = '';
    FilterBranch = CompanyData.map((item) => item.Branch)
    FilterBranch = [...new Set(FilterBranch)];
    FilterBranch.forEach((item) => {
      Branchs.push({value: item, label: item})
    })
    this.setState({ BranchList: FilterBranch, SelectedOptionBranch: Branchs })
  }

  async getFilterBranch(selectedCompany) {
    let FilterBranch = [];
    if (selectedCompany !== '') {
      await this.setState({ BranchList: []});
      FilterBranch = this.state.CompanyBranch.filter((item) => item.Company === selectedCompany)
      FilterBranch = FilterBranch.map((item) => item.Branch)
      FilterBranch = [...new Set(FilterBranch)];
      this.setState({ 
        BranchList: FilterBranch, 
      });
    } else {
      this.setState({ 
        BranchList: [], 
        DepartmenList: [],
        CategoryList: [],
        LatestUpdateList: [],
      });
    }
  }

  async getFilterCategory(selectedDepartment) {
    if (selectedDepartment !== '') {
      let FilterCategory = '';
      await this.setState({ CategoryList: []});
      const getCategoryList = await getCategory(
        this.props.username, 
        this.props.token,
        {
          department: selectedDepartment,
          Category: '', 
          sub1: '', 
          sub2: '', 
          sub3: '', 
          sub4: '',
          sub5: '',
        },
      );
      FilterCategory = getCategoryList.map((item) => item.Category)
      FilterCategory = [...new Set(FilterCategory)];
      this.setState({ CategoryList: FilterCategory, SelectDepartment: selectedDepartment});
    } 
    else {
      this.setState({ 
        CategoryList: [],
      });
    }
  }

  async getFilterSub1(SelectedAns, type) {
    this.ClearSubData(type);
    const AnsArray = (type === 'SelectCategory') ? 'Sub1List' : (type === 'SelectedSub1') ? 'Sub2List' : (type === 'SelectedSub2') ? 'Sub3List' : (type === 'SelectedSub3') ? 'Sub4List' : (type === 'SelectedSub4') ? 'Sub5List' : (type === 'SelectedSub5') ? 'Sub6List' : ''
    if (SelectedAns !== '') {
      const AnsArray = (type === 'SelectCategory') ? 'Sub1List' : (type === 'SelectedSub1') ? 'Sub2List' : (type === 'SelectedSub2') ? 'Sub3List' : (type === 'SelectedSub3') ? 'Sub4List' : (type === 'SelectedSub4') ? 'Sub5List' :  (type === 'SelectedSub5') ? 'Sub6List' : ''
      let FilterSub1 = '';
      await this.setState({ [AnsArray]: []});
      const getCategoryList = await getCategory(
        this.props.username, 
        this.props.token,
        {
          department: this.state.SelectDepartment,
          Category: (type === 'SelectCategory') ? SelectedAns : this.state.SelectCategory, 
          sub1: (type === 'SelectedSub1') ? SelectedAns : this.state.SelectedSub1, 
          sub2: (type === 'SelectedSub2') ? SelectedAns : this.state.SelectedSub2, 
          sub3: (type === 'SelectedSub3') ? SelectedAns : this.state.SelectedSub3, 
          sub4: (type === 'SelectedSub4') ? SelectedAns : this.state.SelectedSub4,
          sub5: (type === 'SelectedSub5') ? SelectedAns : this.state.SelectedSub5,
        },
      );
      const Answer = (type === 'SelectCategory') ? 'Sub1' : (type === 'SelectedSub1') ? 'Sub2' : (type === 'SelectedSub2') ? 'Sub3' : (type === 'SelectedSub3') ? 'Sub4' : (type === 'SelectedSub4') ? 'Sub5' : (type === 'SelectedSub5') ? 'Sub6' :  ''
      FilterSub1 = getCategoryList.map((item) => item[Answer])
      FilterSub1 = [...new Set(FilterSub1)];
      this.setState({ [AnsArray]: FilterSub1, [type]: SelectedAns});
    } 
    else {
      this.setState({ 
        [AnsArray]: [],
      });
    }
  }

  ClearSubData(type) {
    if (type === 'SelectCategory') {
      this.setState({SelectedSub1: '', SelectedSub2: '', SelectedSub3: '', SelectedSub4: '', SelectedSub5: '', SelectedSub6: ''})
    }
    if (type === 'SelectedSub1') {
      this.setState({SelectedSub2: '', SelectedSub3: '', SelectedSub4: '', SelectedSub5: '', SelectedSub6: ''})
    }
    if (type === 'SelectedSub2') {
      this.setState({SelectedSub3: '', SelectedSub4: '', SelectedSub5: '', SelectedSub6: ''})
    }
    if (type === 'SelectedSub3') {
      this.setState({SelectedSub4: '', SelectedSub5: '', SelectedSub6: ''})
    }
    if (type === 'SelectedSub4') {
      this.setState({SelectedSub5: '', SelectedSub6: ''})
    }
    if (type === 'SelectedSub5') {
      this.setState({SelectedSub6: ''})
    }
  }

  SelectedOption(e, type) {
    if (type === 'SelectCompany') {
      if (e.target.value === '') {
        this.setState({ SelectCompany: '', SelectFilterCompany: '' })
        // this.FilteredBranch(JSON.parse(this.props.CompanyData))
      } else {
        // this.getFilterBranch(e.target.value);
        this.setState({ 
          [type]: e.target.value, 
          // DepartmenList: [],
          // CategoryList: [],
          SelectFilterCompany: e.target.value,
        })
      }
    } else if(type === 'SelectBranch') {
      // this.getFilterDepartment(e.target.value);
      this.setState({ 
        [type]: e.target.value,
        CategoryList: [],
        ShowFilterBranch: e.target.value,
      })
    } else if(type === 'SelectDepartment') {
      // this.getFilterCategory(e.target.value);
      this.setState({ [type]: e.target.value, ShowFilterDepart: e.target.value })
    } else if(type === 'SelectCategory' || type === 'SelectedSub1' || type === 'SelectedSub2' || type === 'SelectedSub3' || type === 'SelectedSub4' || type === 'SelectedSub5') {
      this.getFilterSub1(e.target.value, type);
      this.setState({ [type]: e.target.value})
      if (type === 'SelectCategory') {
        this.setState({ ShowFilterSub: e.target.value })
      }
      if (type === 'SelectedSub1') {
        this.setState({ ShowFilterSubSub: e.target.value })
      }
    } else if(type === 'SelectLatestUpdate') {
      this.setState({ [type]: e.target.value, SelectedFilterStatus: e.target.value })
    } else if(type === 'SelectName') {
      if (e.target.value === '') {
        this.setState({ [type]: this.props.username}, () => {
          this.getCategories();
        })
      } 
      else {
        this.setState({ [type]: e.target.value, ShowFilterName: e.target.value}, () => {
          this.getCategories();
        })
      }
     
    } else if(type === 'fromDate') {
      this.setState({ [type]:  moment(e.target.value).format('YYYY-MM-DD')})
    } else if(type === 'toDate') {
      this.setState({ [type]:  moment(e.target.value).format('YYYY-MM-DD')})
    } 
  }

  async UserCallApi(Action){
    this.CallHeader();
    if (Action === true) {
      this.setState({ RunTotalPage: [] })
    }
    const DataObj = {
      selectedUser: this.state.SelectName,
      selectedCompany: this.state.SelectCompany, 
      selectedBranch: this.state.SelectBranch, 
      selectedDepartment: this.state.SelectDepartment, 
      selectedCategory: this.state.SelectCategory,
      subCategory: this.state.SelectedSub1,
      subCategory2: this.state.SelectedSub2,
      subCategory3: this.state.SelectedSub3,
      subCategory4: this.state.SelectedSub4,
      subCategory5: this.state.SelectedSub5,
      subCategory6: this.state.SelectedSub6,
      claimStatus: this.state.SelectLatestUpdate,
      claimAmount: this.state.KeyinAmount,
      approvedAmount: this.state.ApprovedAmount,
      FirstApprove: this.state.FirstApprove,
      FirstApproveStatus: this.state.FirstApproveStatus,
      SecondApprove: this.state.SecondApprove,
      SecondApproveStatus: this.state.SecondApproveStatus,
      Accountant: this.state.Accountant,
    }

    const fromDate = this.state.fromDate
    const toDate = this.state.toDate
    // const getCashout = await ApproverCashoutClaim(this.props.username, fromDate, toDate, 'CashOut', this.props.token)
    const getData = await cashOutClaimListFNC(fromDate, toDate, DataObj, 'CashOut', this.props.username, this.state.page, this.state.countperpage, this.props.token)
    
    if(getData.message === 'No record for these day') {
      this.setState({ claimData: [], TotalAmount: {TotalAmount: 0, TotalApproveAmount: 0} })
    } else {
      this.setState({ claimData: getData.claimList, AllClaimData: getData.claimList, TotalAmount: getData.totalAmtOfClaim, TotalPages: Number(getData.totalPage) }, () => {
        // this.CalculateTotalAmount(this.state.claimData);
        if (this.state.claimData.length > 0) {
          this.setState({ OpenFilter: false })
        }
        this.RunTotalPage();
      })
      if (getData.claimList.length > 0) {
        this.setState({
          countpagemax: Math.ceil(
            getData.claimList[0].FullCount / this.state.countperpage,
          ),
        });
      } else {
        this.setState({
          countpagemax: 1,
          page: 1,
        });
      }
    }
  }

  // CalculateTotalAmount(claimData) {
  //   let Total = {
  //     Amount: 0,
  //     AmountApprove: 0,
  //   }
  //   claimData.forEach((items) => {
  //     Total.Amount += Number(items.Amount)
  //     Total.AmountApprove += Number(items.ApproveAmount)
  //   })
  //   this.setState({ TotalAmount: Total })
  // }

  async getClaimData(Action) {
    this.setState({ 
      // SelectedFilterStatus: 'All',
      // ShowFilterName: 'All',
      // ShowFilterDepart: 'All',
      // ShowFilterBranch: 'All',
      // ShowFilterSub: 'All',
      // ShowFilterSubSub: 'All',
      // ShowFilterApprovalStatus: 'All',
      // ShowFilterSecondApprovalStatus: 'All',
      // SelectFilterCompany: 'All',
      // ShowFilterApproveAmount: 'All',
      // ShowFilterAmount: 'All',
      // ShowFilterApprover: 'All',
      // ShowFilterSecondApprover: 'All',
      // ShowFilterAccounting: 'All',
      page: 1,
      countpagemax: 1,
      countpagemin: 1,
      // SelectName: 'All',
      // SelectCompany: '', 
      // SelectBranch: '', 
      // SelectDepartment: '', 
      // SelectCategory: '',
      // SelectedSub1: '',
      // SelectedSub2: '',
      // SelectedSub3: '',
      // SelectedSub4: '',
      // SelectedSub5: '',
      // SelectedSub6: '',
      // SelectLatestUpdate: '',
      // KeyinAmount: '',
      // ApprovedAmount: '',
      // FirstApprove: '',
      // FirstApproveStatus: '',
      // SecondApprove: '',
      // SecondApproveStatus: '',
      // Accountant: '',
    })
    this.UserCallApi(Action);
  }

  openNotification(message, type) {
    this.setState({ notificationMessage: message, notificationType: type }, () => {
      this.setState({ showNotification: true });
    });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ 
        showNotification: false,
        notificationMessage: ''
      });
    }, 3000);
  };

  SelectedRejects(users) {
    let SelectedRejects = JSON.parse(JSON.stringify(this.state.SelectedRejects))
    if(SelectedRejects.includes(users)) {
      SelectedRejects = SelectedRejects.filter(function (el) {
        return el !== users
      });
    } else {
      SelectedRejects.push(users)
    }
    this.setState({ SelectedRejects })
  }

  async ActionsAccount(SelectedClaim, Selectedtype) {
    if(Selectedtype === 'CashOut') {
      if (SelectedClaim.length > 0) {
        this.MultipleCashoutFunctions(SelectedClaim);
      }
    } else if (Selectedtype === 'MultiReceipt') {
      if (SelectedClaim.length > 0) {
        this.DisplayPrintMultiReceipt(SelectedClaim);
      }
    } else {
      const r = (window.confirm(`${language[this.props.currentLanguage].ConfirmReject}`));
      if (r === true) {
        const RejectClaim = await rejectClaimFNC(SelectedClaim, this.props.username, this.props.token);
        if(RejectClaim.error === 'Don\'t have authorize to update/reject claim') {
          this.openNotification(`${language[this.props.currentLanguage].DontHaveAutho}`,'error')
          this.handleClose();
        } else {
          this.openNotification(`${language[this.props.currentLanguage].SuccessReject}`,'success')
          this.handleClose();
          this.UserCallApi(true);
        }
      } else {
        return null;
      }
    }
  }

  MultipleCashoutFunctions(SelectedClaim) {
    const claimData = this.state.claimData
    let SelectedClaims = []
    let SelectedUSer = []
    for (var i=0; i < SelectedClaim.length; i++) {
      claimData.filter((item) => item.ID === SelectedClaim[i]).forEach((names) => {
        SelectedUSer.push(names.UploadBy)
        SelectedClaims.push(names)
      })
    }
    // SelectedClaim.forEach((names) => {
    //   SelectedUSer.push(names.UploadBy)
    // })
    const allEqual = arr => arr.every( v => v === arr[0] )
    if (allEqual(SelectedUSer) === true) {
      this.setState({ ApproverModal: true, SelectedClaimObject: SelectedClaims, ConsirmPass: true, MultiCashout: true })
    } else {
      this.openNotification(`${language[this.props.currentLanguage].NotAllowMultipleUserClaim}`,'error')
    }
  }

  DisplayPrintMultiReceipt(SelectedClaim, status) {
    const claimData = this.state.claimData
    let SelectedClaims = []
    let SelectedUSer = []
    let RunFunctions = true
    if(status === 'returnreceipt' ) {
      for (var j=0; j < SelectedClaim.length; j++) {
        const Claims = SelectedClaim[j]
        this.state.SelectedClaimObject.filter((item) => item.ID === Claims).forEach((names) => {
          SelectedUSer.push(names.UploadBy)
          SelectedClaims.push(names)
        })
      }
    } else {
      for (var i=0; i < SelectedClaim.length; i++) {
        const Claims = SelectedClaim[i]
        claimData.filter((item) => item.ID === Claims).forEach((names) => {
          SelectedUSer.push(names.UploadBy)
          SelectedClaims.push(names)
        })
      }
    }
    SelectedClaims.forEach((items) => {
      if (items.Status !== 'CashOut') {
        RunFunctions = false
      }
    })
    if (RunFunctions === true) {
      this.setState({ DisplayMultiReceipt: true, ClaimViewReceipt: SelectedClaims })
    } else {
      this.openNotification(`${language[this.props.currentLanguage].SelectedCashoutError}`,'error')
    }
  }

  fastActions(SelectedType) {
    if (SelectedType === 'CashOut') {
      this.setState({ fastCashOutClaim: !this.state.fastCashOutClaim, SelectedCashOutClaim: [], fastActionsReject: false, SelectedRejects: [], fasttype: 'CashOut' })
    } else {
      this.setState({ fastActionsReject: !this.state.fastActionsReject, SelectedRejects: [], fastCashOutClaim: false, SelectedCashOutClaim: [], fasttype: 'Reject' })
    }
  }

  WatchReceipt(ClaimReceipts) {
    this.setState({ OpenViewReceiptModal: true, ClaimViewReceipt: ClaimReceipts })
  }

  CloseViewReceipt() {
    this.setState({ OpenViewReceiptModal: false, ClaimViewReceipt: '' })
  }

  // FilterTableView(e, Selecttype) {
  //   const AllClaimData = this.state.AllClaimData
  //   let SelectedFilterStatus = this.state.SelectedFilterStatus
  //   let FilterResult = []
  //   if(Selecttype === 'ApproverOption') {
  //     SelectedFilterStatus = e
  //     this.setState({ SelectedFilterStatus: e })
  //   }
  //   if(SelectedFilterStatus !== 'All') {
  //     FilterResult = AllClaimData.filter(function (value) {
  //       return value.Status === SelectedFilterStatus
  //     });
  //   } else {
  //     FilterResult = AllClaimData
  //   }
  //   this.setState({ claimData: FilterResult })
  // }

  FilterTableView(e, Selecttype) {
    if(Selecttype === 'ApproverOption') {
      this.setState({ SelectedFilterStatus: e, SelectLatestUpdate: (e === 'All') ? '' : e, }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'ShowFilterName') {
      this.setState({ ShowFilterName: e, SelectName: e }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Department') {
      this.setState({ ShowFilterDepart: [e], SelectDepartment: (e === 'All') ? '' : [e] }, () => { this.UserCallApi(true); this.getCategories(); })
    }
    if(Selecttype === 'Company') {
      this.setState({ SelectFilterCompany: e, SelectCompany: (e === 'All') ? '' : e }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Branch') {
      this.setState({ ShowFilterBranch: e, SelectBranch: (e === 'All') ? '' : e }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Category') {
      this.setState({ ShowFilterSub: e, SelectCategory: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Sub1') {
      this.setState({ ShowFilterSubSub: e, SelectedSub1: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Amount') {
      this.setState({ ShowFilterAmount: e, KeyinAmount: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'FirstApprove') {
      this.setState({ ShowFilterApprover: e, FirstApprove: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'FirstApproveStatus') {
      this.setState({ ShowFilterApprovalStatus: e, FirstApproveStatus: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'SelectedSub1') {
      this.setState({ ShowFilterSubSub: e, SelectedSub1: (e === 'All') ? '' : e}, () => { this.UserCallApi(true); })
    }
    // if(Selecttype === 'SecondApprove') {
    //   this.setState({ ShowFilterSecondApprover: e, SecondApprove: (e === 'All') ? '' : e  }, () => { this.UserCallApi(); })
    // }
    // if(Selecttype === 'SecondApproveStatus') {
    //   this.setState({ ShowFilterSecondApprovalStatus: e, SecondApproveStatus: (e === 'All') ? '' : e  }, () => { this.UserCallApi(); })
    // }
    if(Selecttype === 'ApproveAmount') {
      this.setState({ ShowFilterApproveAmount: e, ApprovedAmount: (e === 'All') ? '' : e }, () => { this.UserCallApi(true); })
    }
    if(Selecttype === 'Accountant') {
      this.setState({ ShowFilterAccounting: e, Accountant: (e === 'All') ? '' : e  }, () => { this.UserCallApi(true); })
    }
    this.setState({ page: 1 })
  }

  OpenApproveModal(SelectedClaim) {
    this.setState({ ApproverModal: true, SelectedClaimObject: SelectedClaim } , ()=> {
      this.DisplayHistorySet();
    })
  }

  handleClose() {
    this.setState({ 
      DisplayMultiReceipt: false,
      AllSelectedIDs: [],
      SelectedAll: false,
      StraighDownload: false,
      MultiCashout: false,
      DisplayHistory: false,
      OpenReceipt: false,
      RedoReturnModal: false,
      ReturnClicked: false,
      ApproverModal: false,
      SelectedClaimObject: {},
      SelectedCashOutClaim: [],
      SelectedRejects: [],
      fastCashOutClaim: false,
      fastActionsReject: false,
      fasttype: '',
      ReasonText: '',
      ConsirmPass: false,
      ErrorMessage: '',
      Password: '',
      HistoryData: [],
    })
  }

  async ConfirmAction(Selectedtype, SelectID) {
    if(Selectedtype === 'Reject') {
      let SelectedClaimArray = []
      SelectedClaimArray.push(SelectID)
      const r = (window.confirm(`${language[this.props.currentLanguage].ConfirmReject}`));
      if (r === true) {
        const RejectClaim = await rejectClaimFNC(SelectedClaimArray, this.props.username, this.props.token);
        if(RejectClaim.error === 'Don\'t have authorize to update/reject claim') {
          this.openNotification(`${language[this.props.currentLanguage].DontHaveAutho}`,'error')
        } else {
          this.openNotification(`${language[this.props.currentLanguage].SuccessReject}`,'success')
          this.handleClose();
          this.UserCallApi(true);
        }
      } else {
        return null;
      }
    } else if (Selectedtype === 'CashOut') {
      let SelectedID = []
      let UploadBy = ''
      if(this.state.MultiCashout === true) {
        SelectID.forEach((SelectedIDs) => {
          SelectedID.push(SelectedIDs.ID)
        })
        UploadBy = SelectID[0].UploadBy
      } else {
        UploadBy = SelectID.UploadBy
        SelectedID.push(SelectID.ID)
      }
      // if(this.state.Password === '') {
      //   this.openNotification(`${language[this.props.currentLanguage].ErrorEmptyPass}`,'error')
      // } else {
      const r = (window.confirm(`${language[this.props.currentLanguage].ConfirmCashOut}`));
      if (r === true) {
        const CashOutclaim = await cashOutClaimFNC(SelectedID, UploadBy, null,this.props.username, this.props.token)
        if(CashOutclaim.error === 'Don\'t have authorize to update/reject claim') {
          this.openNotification(`${language[this.props.currentLanguage].DontHaveAutho}`,'error')
          this.handleClose();
        } else if (CashOutclaim.error === 'Cannot approve / invalid approve') {
          this.openNotification(`${language[this.props.currentLanguage].ErrorCannotCashOut}`,'error')
          this.handleClose();
        } else if(CashOutclaim.error === 'Unable cashout due to wrong password') {
          this.openNotification(`${language[this.props.currentLanguage].ErrorPassword}`,'error')
        }else if(CashOutclaim.message === 'Successful cashout') {
          this.openNotification(`${language[this.props.currentLanguage].SuccessCashOut}`,'success')
          if(SelectedID.length === 1) {
            this.setState({ ApproverModal: true, SelectedClaimObject: CashOutclaim.ReturnData, ConsirmPass: false })
          } else {
            this.setState({ ApproverModal: false, SelectedClaimObject: CashOutclaim.ReturnData, ConsirmPass: false }, ()=>{
              const AllSelectedIDs = []
              for(var i=0; i<this.state.SelectedClaimObject.length; i++) {
                AllSelectedIDs.push(this.state.SelectedClaimObject[i].ID)
              }
              this.DisplayPrintMultiReceipt(AllSelectedIDs, 'returnreceipt'); 
            })
          }
          this.UserCallApi(true);
        }
      } else {
        return null;
      }
      // }
      this.DisplayHistorySet();
    } else if (Selectedtype ==='SetReason') {
      this.setState({ ReasonText: SelectID })
    } else if (Selectedtype === 'return') {
      this.setState({ ReturnClicked: !this.state.ReturnClicked })
    } else if (Selectedtype === 'ConfirmReturn') {
      if(this.state.ReasonText === '') {
        this.openNotification(`${language[this.props.currentLanguage].ErrorReason}`,'error')
      } else {
        let ClaimIDArray = []
        ClaimIDArray.push(SelectID)
        const ReturnClaim = await returnClaimFNC(ClaimIDArray, this.state.ReasonText, this.props.username, this.props.token)
        if (ReturnClaim.message === 'Return successful'){
          this.openNotification(`${language[this.props.currentLanguage].SuccessReturn}`,'success')
          this.handleClose();
          this.UserCallApi(true);
        }
      }
    }
  }
  
  SelectedCashOut(SelectedClaimID) {
    let SelectedCashOutClaim = JSON.parse(JSON.stringify(this.state.SelectedCashOutClaim))
    if(SelectedCashOutClaim.includes(SelectedClaimID)) {
      SelectedCashOutClaim = SelectedCashOutClaim.filter(function (el) {
        return el.ID !== SelectedClaimID.ID
      });
    } else {
      SelectedCashOutClaim.push(SelectedClaimID)
    }
    this.setState({ SelectedCashOutClaim })
  }

  SelectAll(e) {
    const claimData = this.state.claimData
    let ArrayID = []
    if (e.target.checked) {
      claimData.forEach((items) => {
        ArrayID.push(items.ID)
      })
      this.setState({ SelectedAll: true })
    } else {
      ArrayID = []
      this.setState({ SelectedAll: false })
    }
    if (this.state.fastCashOutClaim === true) {
      this.setState({ SelectedCashOutClaim: ArrayID })
    } else if (this.state.fastActionsReject === true) {
      this.setState({ SelectedRejects: ArrayID })
    }
    this.setState({ AllSelectedIDs: ArrayID })
  }

  SelectedReAllID(users) {
    let AllSelectedIDs = JSON.parse(JSON.stringify(this.state.AllSelectedIDs))
    
    if(AllSelectedIDs.includes(users)) {
      AllSelectedIDs = AllSelectedIDs.filter(function (el) {
        return el !== users
      });
    } else {
      AllSelectedIDs.push(users)
    }

    this.setState({ AllSelectedIDs })
  }

  async RedoActions(SelectedClaim) {
    const r = (window.confirm(`${language[this.props.currentLanguage].ConfirmOverrule}`));
    if (r === true) {
      const RedoClaim = await EditClaim({ID: SelectedClaim}, this.state.SelectedClaimObject.Status, this.props.username, this.props.token)
      if(RedoClaim.error === 'database error') {
        this.openNotification(`${language[this.props.currentLanguage].DatabaseError}`,'error')
      }
      if(RedoClaim.message === 'Redo successful') {
        this.openNotification(`${language[this.props.currentLanguage].SuccessruleOver}`,'success')
        this.handleClose();
        this.UserCallApi(true);
      }
    } else {
      return null;
    }
  }

  OpenRedoReturnModal(Selectedclaim) {
    this.setState({ RedoReturnModal: true, SelectedClaimObject: Selectedclaim } , ()=> {
      this.DisplayHistorySet();
    })
  }

  // ExportReceipt(SelectedClaim, type) {
  //   if (type === 'Download') {
  //     ExportPdf(SelectedClaim)
  //   }
  // }

  CloseConfirmPAss() {
    this.setState({ ConsirmPass: false, ErrorMessage: '', Password: '' })
  }

  OpenonfirmPAss() {
    this.setState({ ConsirmPass: true })
  }

  OnchangePassword(e) {
    this.setState({ Password: e })
  }

  async ConfirmPasswordAPI(SelectedClaim) {
    this.ConfirmAction('CashOut', SelectedClaim)
  }

  OpenReceipt() {
    this.setState({ OpenReceipt: !this.state.OpenReceipt, StraighDownload: false })
  }

  DisplayHistorySet() {
    this.setState({ DisplayHistory: !this.state.DisplayHistory }, async() => {
      const EditID = this.state.SelectedClaimObject.ID
      const callHistoryData = await getClaimHistoryRecordFNC(EditID, this.props.username, this.props.token)
      if(callHistoryData.error === 'database error') {
        this.openNotification(`${language[this.props.currentLanguage].DatabaseError}`,'error')
        this.CloseHistorySet();
      } else {
        this.setState({ HistoryData: callHistoryData })
      }
    })
  }

  CloseHistorySet() {
    this.setState({ HistoryData: [], DisplayHistory: false })
  }

  async handleXLSX(){
    const DataObj = {
      selectedUser: this.state.SelectName,
      selectedCompany: this.state.SelectCompany, 
      selectedBranch: this.state.SelectBranch, 
      selectedDepartment: this.state.SelectDepartment, 
      selectedCategory: this.state.SelectCategory,
      subCategory: this.state.SelectedSub1,
      subCategory2: this.state.SelectedSub2,
      subCategory3: this.state.SelectedSub3,
      subCategory4: this.state.SelectedSub4,
      subCategory5: this.state.SelectedSub5,
      subCategory6: this.state.SelectedSub6,
      claimStatus: this.state.SelectLatestUpdate,
      claimAmount: this.state.KeyinAmount,
      approvedAmount: this.state.ApprovedAmount,
      FirstApprove: this.state.FirstApprove,
      FirstApproveStatus: this.state.FirstApproveStatus,
      SecondApprove: this.state.SecondApprove,
      SecondApproveStatus: this.state.SecondApproveStatus,
      Accountant: this.state.Accountant,
    }
    const getExportData = await exportClaimListFNC(this.state.fromDate, this.state.toDate, DataObj, 'CashOut', this.props.username, this.props.token);
   
    await exportCashOutReportExcel(getExportData.claimList, this.state.fromDate, this.state.toDate, this.props.currentLanguage, this.state.BooleanRemoveN)
  }

  async getFilterDepartment(selectedBranch) {
    let FilterDepartment = [];
    if (selectedBranch !== '') {
      await this.setState({ DepartmenList: []});
      FilterDepartment = this.state.CompanyBranch.filter((item) => (item.Branch === selectedBranch && item.Company === this.state.SelectCompany))
      FilterDepartment = FilterDepartment.map((item) => item.Department)
      FilterDepartment = [...new Set(FilterDepartment)];
      this.setState({ DepartmenList: FilterDepartment, SelectBranch: selectedBranch});
    } else {
      this.setState({ 
        DepartmenList: [],
        CategoryList: [],
      });
    }
  }

  ClearFilter() {
    this.setState({ 
      // SelectedFilterStatus: 'All',
      // ShowFilterName: 'All',
      // ShowFilterDepart: 'All',
      // ShowFilterBranch: 'All',
      // ShowFilterSub: 'All',
      // ShowFilterSubSub: 'All',
      // ShowFilterApprovalStatus: 'All',
      // ShowFilterSecondApprovalStatus: 'All',
      // SelectFilterCompany: 'All',
      // ShowFilterApproveAmount: 'All',
      // ShowFilterAmount: 'All',
      // ShowFilterApprover: 'All',
      // ShowFilterSecondApprover: 'All',
      // ShowFilterAccounting: 'All',
      SelectCompany: '',
      SelectBranch: [],
      SelectDepartment: [],
      SelectedSub1: '',
      SelectedSub2: '',
      SelectedSub3: '',
      SelectedSub4: '',
      SelectedSub5: '',
      SelectedSub6: '',
      SelectName: 'All',
      SelectCategory: '',
      SelectLatestUpdate: '',
      KeyinAmount: '',
      ApprovedAmount: '',

      FirstApprove: '',
      FirstApproveStatus: '',
      SecondApprove: '',
      SecondApproveStatus: '',
      Accountant: '',
    })
  }

  SetStatePage(Type) {
    if (Type === 'Next') {
      this.setState({ page: this.state.page + 1 },() => {
        this.changePage();
      })
    } else if (Type === 'previous') {
      this.setState({ page: this.state.page - 1 },() => { this.changePage(this.state.page);})
    } else {
      this.setState({ page: Type },() => { this.changePage();})
    }
  }

  SetStateProps(value){
    this.setState({[value]: !this.state[value]})
  }

  changePage() {
    let RunTotalPage = this.state.RunTotalPage
    const TotalPages = this.state.TotalPages
    let Front = RunTotalPage[0]
    let Back = RunTotalPage[RunTotalPage.length - 1]
    if (TotalPages > 5 && this.state.page === Back && this.state.page !== Number(TotalPages)) {
      if (Number(TotalPages) - Back >= 2) {
        const AfterFilter = RunTotalPage.filter(item => item !== Front && item !== RunTotalPage[1]);
        AfterFilter.push(Back + 1)
        AfterFilter.push(Back + 2)
        this.setState({ RunTotalPage: AfterFilter })
      } else if (Number(TotalPages) - Back === 1) {
        const AfterFilter = RunTotalPage.filter(item => item !== Front);
        AfterFilter.push(Back + 1)
        this.setState({ RunTotalPage: AfterFilter })
      }
    }
    if (TotalPages > 5 && this.state.page === Front && this.state.page !== 1) {
      if (Front - 1 >= 2) {
        const AfterFilter = RunTotalPage.filter(item => item !== Back && item !== RunTotalPage[RunTotalPage.length - 2]);
        AfterFilter.unshift(Front - 1)
        AfterFilter.unshift(Front - 2)
        this.setState({ RunTotalPage: AfterFilter })
      } else if (Front - 1 === 1) {
        const AfterFilter = RunTotalPage
        AfterFilter.unshift(Front - 1)
        this.setState({ RunTotalPage: AfterFilter })
      }
    }
    if (this.state.page === 1 && RunTotalPage.length === 5) {
      this.setState({
        RunTotalPage: [],
      })
    }
    if (this.state.page === TotalPages && RunTotalPage.length === 5) {
      this.setState({ RunTotalPage: [] })
      let AddArray = []
      AddArray.push(Number(TotalPages) - 4)
      AddArray.push(Number(TotalPages) - 3)
      AddArray.push(Number(TotalPages) - 2)
      AddArray.push(Number(TotalPages) - 1)
      AddArray.push(Number(TotalPages))
      this.setState({ RunTotalPage: AddArray })
    }
    this.setState({ claimData: [] }, () => {
      this.UserCallApi();
    });
  }

  RunPageViews(Pages) {
    this.setState({ page: Pages },() => { this.UserCallApi(true) })
  }

  async DeleteClaims(SelectedClaim) {
    const r = (window.confirm(`${language[this.props.currentLanguage].DeleteConfirmation}`));
    if (r === true) {
      const deleteclaim = await DeleteClaim([SelectedClaim.ID], this.props.username, this.props.token);
      if (deleteclaim.message === 'Accountant don\'t have authorize to delete claim') {
        this.openNotification(`${language[this.props.currentLanguage].Fails}`,'error')
      } else {
        if (deleteclaim.message === 'Successful deleted') {
          this.openNotification(`${language[this.props.currentLanguage].SuccessDeleted}`,'success')
          this.handleClose();
          this.UserCallApi(true);
        }
      }
    } else {
      return null;
    }
  }

  handleChangePackageNumber = OptionsPackageNumber => {
    let DepartArray = []
    OptionsPackageNumber.forEach((items) => {
      DepartArray.push(items.value)
    })
    this.setState({ SelectedDeparts: OptionsPackageNumber, SelectDepartment: DepartArray }, () => {this.getCategories()})
  }

  handleChangePackageBranch = OptionsPackageNumber => {
    let BranchArray = []
    OptionsPackageNumber.forEach((items) => {
      BranchArray.push(items.value)
    })
    this.setState({ SelectedBranchs: OptionsPackageNumber, SelectBranch: BranchArray })
  }
  
  render() {
    return (
      <div>
        <Header/>
        <Container fluid className='non-printable' style={{ fontSize: '12px' }}>
          <Alert className='AlertPage' style={{ zIndex: 99, position: 'fixed', right: 0, top: 80 }}show={this.state.showNotification} variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
            <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
          </Alert>
          <RedoReturnModal SelectedClaimObject={this.state.SelectedClaimObject} handleClose={this.handleClose} RedoActions={this.RedoActions} RedoReturnModal={this.state.RedoReturnModal} OpenReceipt={this.state.OpenReceipt} HistoryData={this.state.HistoryData} OpenReceiptFunction={this.OpenReceipt}/>
          {this.state.DisplayMultiReceipt === true &&
            <MultiplePrint
              DisplayPrintMultiReceipt={this.DisplayPrintMultiReceipt}
              DisplayMultiReceipt={this.state.DisplayMultiReceipt}
              ClaimViewReceipt={this.state.ClaimViewReceipt}
              ConsirmPass={this.state.ConsirmPass}
              handleClose={this.handleClose}
            />
          }
          {this.state.ApproverModal === true && 
        <ApproverCashOutModal 
          MultiCashout={this.state.MultiCashout}
          ApproverModal={this.state.ApproverModal}
          SelectedClaimObject={this.state.SelectedClaimObject}
          CloseConfirmPAss={this.CloseConfirmPAss}
          OpenReceiptFunction={this.OpenReceipt}
          StraighDownload={this.state.StraighDownload}
          DisplayHistory={this.state.DisplayHistory}
          DisplayHistorySet={this.DisplayHistorySet}
          Password={this.state.Password}
          HistoryData={this.state.HistoryData}
          ConfirmPasswordAPI={this.ConfirmPasswordAPI}
          OnchangePassword={this.OnchangePassword}
          OpenonfirmPAss={this.OpenonfirmPAss}
          ConsirmPass={this.state.ConsirmPass}
          ErrorMessage={this.state.ErrorMessage}
          notificationMessage={this.state.notificationMessage}
          notificationType={this.state.notificationType}
          ReasonText={this.state.ReasonText}
          ReturnClicked={this.state.ReturnClicked}
          showNotification={this.state.showNotification}
          uploadloading={this.state.uploadloading}
          OpenReceipt={this.state.OpenReceipt}
          handleClose={this.handleClose}
          ConfirmAction={this.ConfirmAction}
          PageType={'CashOut'}
        />
          }
          <ViewReceiptModal OpenViewReceiptModal={this.state.OpenViewReceiptModal} CloseViewReceipt={this.CloseViewReceipt} ClaimsData={this.state.ClaimViewReceipt} HistoryData={this.state.HistoryData} />
          <div className='ApproverCashOutHeaderCover'>
            <div className='ApproverCashOutHeaderdesign'>
              <h2 style={{ marginRight: 10 }}>{language[this.props.currentLanguage].CashOut}</h2>
              <Form.Control value={this.state.fromDate} onChange={(e) => this.setState({ fromDate: e.target.value })} type="date" style={{ marginRight: 10, width: 140, minWidth: 140 }}/>
              <div style={{ marginRight: 10 }}>-</div>
              <Form.Control value={this.state.toDate} onChange={(e) => this.setState({ toDate: e.target.value })} type="date" style={{ marginRight: 10, width: 140, minWidth: 140 }}/>
              {/* <Button variant="success" onClick={() => this.getClaimData()}>{language[this.props.currentLanguage].Search}</Button> */}
              <div className="dcc button ClaimSearch"
                style={{ backgroundColor: this.state.background,
                  fontWeight: 'bold', padding: 7 , cursor: 'pointer', borderRadius: 5, paddingLeft: 12, paddingRight: 12}} 
                onMouseEnter={() => {
                  this.setState({ background: '#00B79B' });
                }}
                onMouseLeave={() => {
                  this.setState({ background: '#0D6EFD' });
                }}
                variant="success" onClick={() => this.getClaimData(true)}>
                <span>
                  {language[this.props.currentLanguage].Search}
                </span>
              </div>
            </div>
            {this.state.claimData.length > 0 && 
            <div className='dcc' style={{ marginLeft: 5 }}>
              {/* {(this.state.fastCashOutClaim && this.state.SelectedCashOutClaim.length > 0) &&
              <Button variant="success" style={{ marginRight: 10}} onClick={()=> this.ActionsAccount(this.state.SelectedCashOutClaim, 'CashOut')}>{'出纳'}</Button>
              } */}
              {/* {((this.state.ShowFilterName !== 'All' && this.state.ShowFilterName !== '') && 
              (this.state.ShowFilterAccounting !== 'All' && this.state.ShowFilterAccounting !== ''))&&<Button style={{ marginRight: 10, }}
                onClick={()=> this.handleXLSX()}>{'XLSX'}</Button>} */}
              {/* <Button style={{ marginRight: 10, }}
                onClick={()=> this.handleXLSX()}>{'XLSX'}</Button> */}
              <Button variant={this.state.BorderHide ? "success" :"secondary"} 
                onClick={()=> this.setState({BorderHide: !this.state.BorderHide})}>{this.state.BorderHide ? language[this.props.currentLanguage].Expand : language[this.props.currentLanguage].Minimize}</Button>
              <Button style={{ marginRight: 10, marginLeft: 10 }} onClick={()=> this.ActionsAccount(this.state.AllSelectedIDs, 'MultiReceipt')}>{language[this.props.currentLanguage].MultiReceipt}</Button>
              <Button variant={'warning'} style={{ marginRight: 10,  marginLeft: 10 }} onClick={()=> this.ActionsAccount(this.state.AllSelectedIDs, 'CashOut')}>{'快速出纳'}</Button>
              {this.props.role === 'CEO' && 
                <Button variant={'danger'}  style={{ marginRight: 10 }} onClick={()=> this.ActionsAccount(this.state.AllSelectedIDs, 'Reject')}>{language[this.props.currentLanguage].FastReject}</Button>
              }
              {/* <Button style={{ marginLeft: 10, marginRight: 10, backgroundColor: (this.state.fastCashOutClaim === true) ? 'blue' : 'orange' }} 
                onClick={()=> this.fastActions('CashOut')}>{(this.state.fastCashOutClaim === true) ? '取消快速出纳' : '快速出纳'}</Button> */}
              {/* {(this.state.fastActionsReject && this.state.SelectedRejects.length > 0) &&
              <Button variant="danger" style={{ marginRight: 10}} onClick={()=> this.ActionsAccount(this.state.SelectedRejects, 'Reject')}>{language[this.props.currentLanguage].Reject}</Button>
              }
              <Button style={{ marginRight: 10, backgroundColor: (this.state.fastActionsReject === true) ? 'blue' : 'red' }} 
                onClick={()=> this.fastActions('Reject')}>{(this.state.fastActionsReject === true) ? `${language[this.props.currentLanguage].CancelFastReject}`: `${language[this.props.currentLanguage].FastReject}`}</Button> */}
            </div>
            }
          </div>
          {this.state.OpenFilter && 
        <>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%'}}>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 5}}>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto',  width: '25%' }}>{language[this.props.currentLanguage].Company}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select value={this.state.SelectFilterCompany} style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectCompany')}>
                    <option value=''></option>
                    {this.state.CompanyList.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div  style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].Branch}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  {/* <Form.Select    value={this.state.ShowFilterBranch} style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectBranch')}>
                    <option value=''></option>
                    {this.state.BranchList.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select> */}
                  {this.state.SelectedOptionBranch.length > 0 && 
                  <div style={{ width: 250, maxWidth: 250 }}>
                    <Select closeMenuOnSelect={false} isMulti options={this.state.SelectedOptionBranch} value={this.state.SelectedBranchs} onChange={this.handleChangePackageBranch}/>
                  </div>
                  }
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].Subject}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select 
                    value={this.state.ShowFilterSub}
                    style={{ width: 250}}  onChange={(e) => this.SelectedOption(e, 'SelectCategory')}>
                    <option value=''></option>
                    {this.state.FilterSub.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 2</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub2')}>
                    <option value=''></option>
                    {this.state.Sub2List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 4</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub4')}>
                    <option value=''></option>
                    {this.state.Sub4List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 6</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub6')}>
                    <option value=''></option>
                    {this.state.Sub6List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div> */}
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].Amount}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Control  value={this.state.KeyinAmount} readOnly={false} style={{ width: 250, textAlign: 'center', backgroundColor: 'white' }} onChange={(e) => this.setState({ KeyinAmount: e.target.value })}/>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 5, marginBottom: 10}}>
              <div  style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].Name}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  {this.props.role === 'User' && 
                      <Form.Select style={{ width: 250}}
                        value={this.state.ShowFilterName}
                        onChange={(e) => this.SelectedOption(e, 'SelectName')} disabled={true}>
                        <option value={this.props.username}>{this.props.username}</option>
                      </Form.Select>
                  }
                  {this.props.role !== 'User' && 
                      <Form.Select 
                        value={this.state.ShowFilterName}
                        style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectName')}>
                        <option value='All'>{language[this.props.currentLanguage].All}</option>
                        {/* {this.props.role === 'Account' && <option value={this.props.username}>{this.props.username}</option>} */}
                        {this.state.UserList.map((item, index) => 
                          <option key={index} value={item.ID}>{item.Name}</option>
                        )}
                      </Form.Select>
                  }
                </div>
              </div>
              <div  style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].Department}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  {/* <Form.Select style={{ width: 250}} 
                    value={this.state.ShowFilterDepart}
                    onChange={(e) => this.SelectedOption(e, 'SelectDepartment')}>
                    <option value=''></option>
                    {this.state.FilterDepartment.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select> */}
                  {this.state.SelectedOptionDepart.length > 0 && 
                  <div style={{ width: 250, maxWidth: 250 }}>
                    <Select closeMenuOnSelect={false} isMulti options={this.state.SelectedOptionDepart} value={this.state.SelectedDeparts} onChange={this.handleChangePackageNumber}/>
                  </div>
                  }
                </div>
              </div>
              {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 1</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub1')}>
                    <option value=''></option>
                    {this.state.Sub1List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 3</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub3')}>
                    <option value=''></option>
                    {this.state.Sub3List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].SubSubject} 5</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectedSub5')}>
                    <option value=''></option>
                    {this.state.Sub5List.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div> */}
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].LatestStatus}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select 
                    value={this.state.SelectedFilterStatus}
                    style={{ width: 250}} onChange={(e) => this.SelectedOption(e, 'SelectLatestUpdate')}>
                    <option value=''></option>
                    {this.state.LatestUpdateList.map((item, index) => 
                      <option key={index} value={item}>{item}</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{'Page'}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Select style={{ width: 250}} value={this.state.countperpage} onChange={(e) => this.setState({ countperpage: e.target.value })}>
                    <option value='20'>20</option>
                    <option value='30'>30</option>
                    <option value='50'>50</option>
                    <option value='100'>100</option>
                  </Form.Select>
                </div>
              </div>
              {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5}}>
                <div className='ReportSelectTitle'>{language[this.props.currentLanguage].ApprovedAmount}</div>
                <div style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
                  <Form.Control  value={this.state.ApprovedAmount} readOnly={true} style={{ width: 250, textAlign: 'center', backgroundColor: 'white'  }}/>
                </div>
              </div> */}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', marginRight: '13%',  marginLeft: '13%', justifyContent: 'space-between'}}>
            <div className="dcc button"
              style={{ backgroundColor: this.state.background,
                fontWeight: 'bold', padding: 7 , cursor: 'pointer', borderRadius: 5, width: 200, marginBottom: 10, marginTop: 5 }}
              variant="success" onClick={() => this.getClaimData(true)}>
              <span>
                {language[this.props.currentLanguage].Search}
              </span>
            </div>
          </div>
        </>
          }
          {this.state.OpenFilter === false && 
        <div style={{ display: 'flex', flexDirection: 'row', marginRight: '13%', justifyContent: 'space-between'}}>
          <div className="dcc button"
            style={{ backgroundColor: this.state.background,
              fontWeight: 'bold', padding: 7 , cursor: 'pointer', borderRadius: 5, width: 200, marginBottom: 10 }}
            variant="success" onClick={() => this.setState({ OpenFilter: !this.state.OpenFilter }, () => {
              // this.ClearFilter();
            })}>
            <span>
              {'OpenFilter'}
            </span>
          </div>
        </div>}
          <div className='dcc'>
            <DisplayTable
              BorderHide={this.state.BorderHide}
              SetStateProps={this.SetStateProps}
              handleXLSX={this.handleXLSX}
              RunPageViews={this.RunPageViews}
              TotalPages={this.state.TotalPages}
              RunTotalPage={JSON.parse(JSON.stringify(this.state.RunTotalPage))}
              SetStatePage={this.SetStatePage}
              page={this.state.page}
              countpagemin={this.state.countpagemin}
              countpagemax={this.state.countpagemax}
              FilterTableView={this.FilterTableView}
              RedoActions={this.RedoActions}
              DeleteClaims={this.DeleteClaims}
              TotalAmount={this.state.TotalAmount}
              SelectedFilterStatus={this.state.SelectedFilterStatus}
              OpenRedoReturnModal={this.OpenRedoReturnModal}
              FilterStatus={this.state.FilterStatus}
              claimData={this.state.claimData}
              FilterName={this.state.FilterName}
              FilterCompany={this.state.FilterCompany}
              FilterBranch={this.state.FilterBranch}
              FilterDepart={this.state.FilterDepartment}
              FilterAmount={this.state.FilterAmount}
              FilterApproveAmount={this.state.FilterApproveAmount}
              FilterApprove={this.state.FilterApprove}
              FilterApprovalStatus={this.state.FilterApprovalStatus}
              // FilterSecondApprover={this.state.FilterSecondApprover}
              // FilterSecondApprovalStatus={this.state.FilterSecondApprovalStatus}
              FilterAccounting={this.state.FilterAccounting}
              FilterSub={this.state.FilterSub}
              FilterSubSub={this.state.FilterSubSub}
              ShowFilterStatus={this.state.SelectedFilterStatus}
              ShowFilterCompany={this.state.SelectFilterCompany}
              ShowFilterBranch={this.state.ShowFilterBranch}
              ShowFilterDepartment={this.state.ShowFilterDepart}
              ShowFilterName={this.state.ShowFilterName}
              ShowFilterSub={this.state.ShowFilterSub}
              ShowFilterSubSub={this.state.ShowFilterSubSub}
              ShowFilterApprovalStatus={this.state.ShowFilterApprovalStatus}
              // ShowFilterSecondApprovalStatus={this.state.ShowFilterSecondApprovalStatus}
              ShowFilterApproveAmount={this.state.ShowFilterApproveAmount}
              ShowFilterAmount={this.state.ShowFilterAmount}
              ShowFilterApprover={this.state.ShowFilterApprover}
              // ShowFilterSecondApprover={this.state.ShowFilterSecondApprover}
              ShowFilterAccounting={this.state.ShowFilterAccounting}
              role={this.props.role}
              username={this.props.username}
              WatchReceipt={this.WatchReceipt}
              SelectAll={this.SelectAll}
              SelectedAll={this.state.SelectedAll}
              selectedIDs={this.state.SelectedCashOutClaim}
              SelectedRejectsID={this.state.SelectedRejects}
              SelectedRejects={this.SelectedRejects}
              fastActionsReject={this.state.fastActionsReject}
              fastCashOutClaim={this.state.fastCashOutClaim}
              fasttype={this.state.fasttype}
              pagetype={this.state.pagetype}
              SelectedReAllID={this.SelectedReAllID}
              AllSelectedIDs={this.state.AllSelectedIDs}
              BooleanRemoveN={this.state.BooleanRemoveN}
              OpenApproveModal={this.OpenApproveModal}
              SelectedCashOut={this.SelectedCashOut}/>
          </div>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.currentLanguage,
    username: state.username,
    token: state.token,
    role: state.role,
    CompanyData: state.CompanyData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (Username, UserToken, Role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          username: Username,
          token: UserToken,
          Role: Role,
        },
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CashOut);
